import "./es.array.join-c1bca812.js";
import "./es.parse-float-020a2ae0.js";
import "./es.regexp.constructor-6da4b85c.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.regexp.to-string-e800d529.js";
import "./export-cdcbfb2b.js";
import "./array-method-is-strict-e5a3c878.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./string-trim-14e37ad3.js";
import "./inherit-if-required-f068457b.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./object-create-9b6715a2.js";
import "./object-keys-719a5561.js";
import "./html-32ef1b46.js";
import "./is-regexp-4c49b1c2.js";
import "./set-species-5ede2ed0.js";
import "./define-built-in-accessor-26bc7b69.js";
import "./function-apply-4756dee6.js";
var e = ["$", "€", "£", "¥", "₹", "₽", "₩", "₪", "₫", "฿", "₴", "₱", "₲", "₵", "₣", "₺", "₼", "₦", "₡", "₭", "₸", "د\\.إ", "ر\\.س", "﷼", "د\\.ب", "د\\.ك", "د\\.ع", "ر\\.ع", "৳", "₮", "৲", "₠", "₤", "ƒ"], i = "(?:" + e.join("|") + ")", o = "\\d{1,3}(?:[.,\\s]\\d{3})*(?:[.,]\\d{2})?", p = "\\d+(?:[.,]\\d*)?", m = "(?:" + o + "|" + p + ")", a = "^(?:" + i + "\\s?)?" + m + "$", n = new RegExp(a), E = function(r) {
  return n.test(r);
}, F = function(r) {
  return parseFloat(r.replace(/[^0-9.-]+/g, ""));
};
export {
  E as isCurrency,
  F as parseCurrency
};
